import React, { Component } from 'react';

class Home extends Component {
    state = {  }
    render() { 
        return <h2>Hello from the Home component!</h2>;
    }
}
 
export default Home;